import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=339ae4ac&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339ae4ac')) {
      api.createRecord('339ae4ac', component.options)
    } else {
      api.reload('339ae4ac', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=339ae4ac&", function () {
      api.rerender('339ae4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4h3u5z1Z3gd7G/JS/comp/FavElement.vue"
export default component.exports